import React from 'react';
import { DownloadDocument } from './DownloadDocument/DownloadDocument';
import { ExpandDocument } from './ExpandDocument/ExpandDocument';

export const DocumentActions = ({ isCreditCard, handleOnStartFileDownload, precontractualLinks, productsInfo }) => {
    return (
        <div className="col-xs-6 text-right">
            <DownloadDocument
                handleOnStartFileDownload={handleOnStartFileDownload}
                precontractualLinks={precontractualLinks}
            />
            {!isCreditCard && <ExpandDocument productsInfo={productsInfo} />}
        </div>
    );
};
